import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
    },
    {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canLoad: [AuthGuard]
    },
    {
        path: 'user-guide',
        loadChildren: () => import('./pages/user-guide/user-guide.module').then(m => m.UserGuideModule),
        canLoad: [AuthGuard],
    },
    {
        // Invalid route - redirect to default home
        path: '**', redirectTo: '/'
    },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
